import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Table from '../components/common/Table';
import BaseApiManager from '../networking/baseAPIManager';
import { API_ENDPOINTS } from '../networking/apiConfig';
import moment from 'moment';

const User = () => {
  const [userData, setUserData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchUsers = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await BaseApiManager.get(API_ENDPOINTS.GET_ALL_USERS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Sort by newest createdAt first
      const sorted = response.users
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      const formatted = sorted.map((user) => ({
        name: user.name,
        email: user.email,
        phonenumber: user.phonenumber || '---',
        role: user.role,
        createdAt: moment(user.createdAt).format('MMM D, YYYY'),
      }));

      setUserData(formatted);
    } catch (error) {
      console.error('Failed to fetch users:', error);
      toast.error('Failed to load users');
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const columns = [
    { Header: 'Name', accessor: 'name' },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Contact', accessor: 'phonenumber' },
    { Header: 'Role', accessor: 'role' },
    { Header: 'Created At', accessor: 'createdAt' },
  ];

  const filteredData = userData.filter((user) =>
    `${user.name} ${user.email} ${user.phonenumber} ${user.role}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="mt-8 px-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">All Users</h2>
        <input
          type="text"
          placeholder="Search users..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border border-gray-300 px-3 py-1.5 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
        />
      </div>
      <Table columns={columns} data={filteredData} />
    </div>
  );
};

export default User;
